import store from '@store';
import { isNotEmpty } from "../utils.js";
// Create a simple Vue plugin to expose the wrapper object throughout the application

export const ProfileCheckerPlugin = {
  install(Vue, options) {
    Vue.prototype.$checkProfileWithRedirect = function() {
      const profile = store.getters.getUser;
      const checkCommonProfile = (profile) => {
        return isNotEmpty(profile.firstname) && isNotEmpty(profile.surname) && isNotEmpty(profile.email);
      }
      const checkDriverProfile = (profile) => {
        const checkStep2 = () => isNotEmpty(profile.car_make) && isNotEmpty(profile.car_model);
        const checkStep3 = () => true;
        const checkStep4 = () => true;
          console.log(profile, checkCommonProfile(profile));
        if (!checkCommonProfile(profile)) {
          this.$router.replace({ path: "/driver-profile-completion#step-1" });
        } else if (!checkStep2(profile)) {
          this.$router.replace({ path: "/driver-profile-completion#step-2" });
        } else if (!checkStep3(profile)) {
          this.$router.replace({ path: "/driver-profile-completion#step-3" });
        } else if (!checkStep4(profile)) {
          this.$router.replace({ path: "/driver-profile-completion#step-4" });
        } else {
          this.$router.replace({ path: "/driver/account" });
        }
      }
      const checkAdvertiserProfile = () => {
        if (!checkCommonProfile(profile)) {
          this.$router.replace({ path: "/advertiser-profile-completion" });
        } else {
          this.$router.replace({ path: "/advertiser/dashboard" });
        }
      }
        console.log("profile", profile);
      if (profile.role == "admin") {
        this.$router.replace({ path: "/admin" });
      } else if (profile.role == "driver") {
        checkDriverProfile(profile);
      } else {
        checkAdvertiserProfile(profile);
      }
    };
  }
};
